export enum BankDetailsStatus {
  SET = 'set',
  MISSING = 'missing'
}

export interface BankAccountUIModel {
  id?: string;
  landlordId: string;
  bankName: string;
  accountHolderName: string;
  accountNumber: string;
  swiftBic: string;
  country: string;
  currency: string;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
}

export interface LandlordRowUIModel {
  landlordId: string;
  name: string;
  email: string;
  phone: string;
  unitsCount: number;
  bankDetailsStatus: BankDetailsStatus;
  lastUpdatedAt: string;
}

export interface LandlordListUIModel {
  rows: LandlordRowUIModel[];
  page: number;
  pageSize: number;
  total: number;
  totalMissingBankDetails: number;
}

export interface LandlordUnitUIModel {
  id: string;
  name: string;
  propertyName: string;
  areaName: string;
  landlordShare: number;
}

export interface BankAccountAuditUIModel {
  action: string;
  source: string;
  batchId: string;
  changes: { field: string; oldValue: string; newValue: string }[];
  performedBy: string;
  performedAt: string;
}

export interface LandlordDetailUIModel {
  landlordId: string;
  name: string;
  email: string;
  phone: string;
  bankAccount: BankAccountUIModel | null;
  units: LandlordUnitUIModel[];
  audit: BankAccountAuditUIModel[];
}

export interface BankAccountFormUIModel {
  bankName: string;
  accountHolderName: string;
  accountNumber: string;
  swiftBic: string;
  country: string;
  currency: string;
}
